<template>
  <div class="db-rank card">
    <div class="db-rank__header">
      <h5>{{ title }}</h5>
      <p>{{ subtitle }}</p>
    </div>

    <ul v-if="items.length" class="db-rank__list">
      <li v-for="(row, idx) in items" :key="`${row.rfc}-${idx}`" class="db-rank__item">
        <div class="db-rank__left">
          <span class="db-rank__idx">{{ idx + 1 }}</span>
          <div>
            <p class="db-rank__name">{{ row.name || 'Sin nombre' }}</p>
            <p class="db-rank__rfc">{{ row.rfc || 'Sin RFC' }}</p>
          </div>
        </div>
        <strong class="db-rank__amount">{{ formatCurrency(row.total) }}</strong>
      </li>
    </ul>

    <div v-else class="db-rank__empty">No hay suficientes CFDIs para construir este ranking.</div>
  </div>
</template>

<script>
export default {
  name: 'DashboardRankList',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    items: { type: Array, default: () => [] },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(value || 0));
    },
  },
};
</script>

<style scoped>
.db-rank {
  border-radius: 16px;
  border: 1px solid rgba(115, 102, 255, 0.2);
  box-shadow: 0 10px 24px rgba(10, 48, 62, 0.08);
  margin-bottom: 1rem;
}

.db-rank__header {
  padding: 1rem 1rem 0.2rem;
}

.db-rank__header h5 {
  margin: 0;
  font-size: 1rem;
  color: var(--theme-deafult);
}

.db-rank__header p {
  margin: 0.2rem 0 0;
  font-size: 12px;
  color: #5b7482;
}

.db-rank__list {
  list-style: none;
  margin: 0;
  padding: 0.25rem 0.6rem 0.75rem;
}

.db-rank__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px dashed #d6e4ea;
  padding: 0.65rem 0.35rem;
}

.db-rank__left {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-width: 0;
}

.db-rank__idx {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(115, 102, 255, 0.14);
  color: var(--theme-deafult);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
}

.db-rank__name {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #173847;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 190px;
}

.db-rank__rfc {
  margin: 0;
  font-size: 11px;
  color: #6a808c;
}

.db-rank__amount {
  font-size: 12px;
  color: var(--theme-secondary);
}

.db-rank__empty {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #5d7685;
  padding: 1rem;
  font-size: 13px;
}
</style>
